import Box from '@mui/material/Box'
import React from 'react'
import TextValue from '../../../../../text/TextValue'
import SectionCollapse from '../../../../../section/SectionCollapse'
import PaperBase from '../../../../../Paper/PaperBase'
import { Typography } from '@mui/material'
import isEqual from 'lodash/isEqual'

const ItemLC = ({ item, invert }) => (
  <div className="flex flex-nowrap  w-full gap-1" key={item._id}>
    <PaperBase 
      backgroundColor={item?.secondaryColor}
      color={item?.primaryColor}
      className='font-bold  min-w-120px max-w-120px overflow-hidden'
      children={item.name}
    />
    <PaperBase 
      backgroundColor={item.isDefinition ? invert ? item?.primaryColor : item?.secondaryColor : null}
      color={item.isDefinition ? invert ? item?.secondaryColor : item?.primaryColor : null}
      className={[
        'w-full overflow-auto',
        item.isDefinition ? '' : 'bg-lines'
      ].join(' ')}
      children={item.definition}
    />
  </div>
)

const ItemCurriculum = ({ id, item = {}, oldValues }) => {
  return (
    <>
      {Object.keys(item?.children || {}).map((key) => 
        <ItemCurriculum 
          key={`id-${id}-key-${key}`}
          id={key}
          item={item?.children[key]}
          oldValues={oldValues?.children ? oldValues?.children[key] : null}
        />
      )}
      <div className="flex flex-nowrap  w-full gap-1" key={item?._id}>
        <PaperBase 
          backgroundColor={item?.primaryColor}
          color={item?.secondaryColor}
          className='font-bold  min-w-120px max-w-120px overflow-hidden'
          children={item.name || id}
        />
        <PaperBase 
          backgroundColor={item.value ? item?.primaryColor : null}
          color={item.value ? item?.secondaryColor : null}
          className={[
            'w-full text-ellipsis overflow-auto',
            item.value ? '' : 'bg-lines'
          ].join(' ')}
          children={
            <div className='overflow-hidden'>
              { oldValues && !isEqual(oldValues?.value?.name || oldValues?.value, item?.value?.name || item?.value) &&
                <Typography variant='inherit' component={'p'} className='opacity-50 line-through text-ellipsis bg-muted text-muted-foreground p-1'>
                  {oldValues?.value?.name || oldValues?.value || 'No value'}
                </Typography>
              }
              <Typography variant='inherit' component={'p'} className='text-ellipsis'>
                {item?.value?.name || item?.value || 'No value'}
              </Typography>
            </div>
          }
        />
      </div>
    </>
  )
}
const LearningContinuumInfo = ({ title = "Preview", detail, showCurriculumName = true, oldValues = {} }) => {
  return (
    <Box className='py-1 flex flex-col gap-1 w-full'>
      { showCurriculumName && <TextValue title='Curriculum' value={detail.curriculum} /> }
      <SectionCollapse title={title}>
        <div className='flex flex-col gap-1 w-full'>
          {detail?.levels?.sort((a, b) => b.position - a.position)
            .map((item) => (
              <ItemLC
                key={item.levelId}
                invert={true}
                item={{
                  _id: item._id || item.levelId,
                  name: item.name || item.levelId,
                  isDefinition: item.definition,
                  definition: <div className='overflow-hidden'>
                    { oldValues?.levels && oldValues?.levels?.find((l) => l.levelId === item.levelId) &&
                      <Typography variant='inherit' component={'p'} className='opacity-50 line-through text-ellipsis bg-muted text-muted-foreground p-1'>
                        {oldValues?.levels?.find((l) => l.levelId === item.levelId)?.definition ?? ''}
                      </Typography>
                    }
                    <Typography variant='inherit' component={'p'} className='text-ellipsis'>
                      {item.definition}
                    </Typography>
                  </div>,
                  position: item.position,
                  primaryColor: item.primaryColor,
                  secondaryColor: item.secondaryColor
                }} 
              />
          ))}
          {Array.isArray(detail?.lcElements) 
            ? detail?.lcElements?.sort((a, b) => b.position - a.position)
            .map((item) => (
              <ItemLC
                key={item.elementId}
                item={{
                  ...item,
                  isDefinition: !!item.definition,
                  definition: <div>
                    {oldValues?.lcElements &&
                      <Typography variant='inherit' component={'p'} className='opacity-50 line-through text-ellipsis bg-muted text-muted-foreground p-1'>
                        {oldValues?.lcElements[item.elementId] ?? ''}
                      </Typography>
                    }
                    <Typography variant='inherit' component={'p'} className='text-ellipsis'>
                      {item.definition}
                    </Typography>
                  </div>
                }} 
              />
            ))
          : 
            Object.keys(detail?.lcElements || {})
            .map((key, idx) => (
              <ItemLC
                key={key}
                item={{
                  _id: key,
                  name: key,
                  isDefinition: !!detail?.lcElements[key],
                  definition: <div>
                    <Typography variant='inherit' component={'p'} className='opacity-75 line-through'>
                      {oldValues?.lcElements ? oldValues?.lcElements[key] ?? '' : ''}
                    </Typography>
                    <Typography variant='inherit'>
                      {detail?.lcElements[key]}
                    </Typography>
                  </div>,
                  position: idx
                }} 
              />
            ))
          }
          {Object.keys(detail?.curriculumElements || {}).map((key) => 
            <ItemCurriculum 
              id={key}
              key={key}
              item={detail?.curriculumElements[key]} 
              oldValues={oldValues?.curriculumElements ? oldValues?.curriculumElements[key] : null}
            />
          )}
        </div>
      </SectionCollapse>
    </Box>
  )
}

export default LearningContinuumInfo